import React from "react";

export default function IconChecked() {
  return (
    <svg
      height="20"
      viewBox="0 0 170 170"
      width="20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="m146.756 69.865c-2.731.411-4.611 2.958-4.2 5.688 5.986 38.218-24.691 73.902-63.436 73.566-85.055-3.519-85.048-124.726 0-128.24 14.308 0 27.84 4.609 39.133 13.328 2.188 1.688 5.326 1.283 7.014-.902s1.283-5.326-.902-7.014c-13.06-10.083-28.705-15.412-45.245-15.412-98.316 4.063-98.315 144.179 0 148.24 44.788.385 80.259-40.868 73.323-85.055-.411-2.73-2.955-4.617-5.688-4.2z"></path>
      <path d="m163.528 23.274c-1.959-1.949-5.124-1.942-7.071.016l-76.991 77.326-25.41-25.526c-1.949-1.957-5.114-1.964-7.071-.017-1.957 1.948-1.965 5.114-.017 7.071l28.954 29.086c.938.942 2.214 1.473 3.544 1.473s2.604-.53 3.543-1.473l80.534-80.885c1.948-1.956 1.941-5.122-.015-7.07z"></path>
    </svg>
  );
}
